import Component from '../Component';
import $ from '../../vendor/CustomJquery';

export default class Submitter extends Component {

  _FORM_ERROR_TEMPLATE  = '<div class="message %type%"><div class="message-body">%message%</div></div>';

  _FIELD_ERROR_TEMPLATE = '<p class="help is-danger">%message%</p>';

  _MESSAGE_TYPES = {
    error:   'is-danger',
    success: 'is-success'
  };

  configure() {
    return super.configure();
  }

  initialize() {
    this.subscribeToEvents();
    return super.initialize();
  }

  subscribeToEvents() {
    $(document).on('click', 'button[type="submit"][name="action"]', (event) => {
      return this.onActionButtonClick(event);
    });
    $(document).on('submit', 'form[data-action]', (event) => {
      return this.onSubmit(event);
    });
    $(document).on('submit', 'form:not([data-action])', (event) => {
      return this.lockForm(event);
    });
    $(document).on('click', '.external-submit-button', (event) => {
      return this.onExternalSubmitButtonClick(event);
    });
  }

  lockForm(event) {
    let form = $(event.currentTarget);

    this.lockSubmitButtons(form);
    setTimeout(() => {
      this.unlockSubmitButtons(form);
    }, 5000);
  }

  onActionButtonClick(event) {
    let button = $(event.currentTarget),
        form = button.closest('form'),
        actionInput = form.find('input[name="action"]');

    if (form.length === 1) {
      if (actionInput.length === 1) actionInput.val(button.attr('value'));
      else {
        form.prepend(`<input type="hidden" name="action" value="${button.attr('value')}">`);
      }
    }
  }

  onExternalSubmitButtonClick(event) {
    let button = $(event.currentTarget),
      form = $(`#${button.data('target')}`);

    event.preventDefault();
    form.submit();
  }

  onSubmit(event) {

    let form = $(event.currentTarget),
        method = (form.attr('method') || 'get').toLowerCase() || 'get',
        url  = form.data('action'),
        actionEvent = form.data('event'),
        data = form.serializeObject();

    this.logger('Form ['+ method +']', form, 'was submitted with data:', data);

    this.resetErrors(form);
    this.lockSubmitButtons(form);

    event.preventDefault();

    this.App.API[method](url, data).then((response) => {

      this.unlockSubmitButtons(form);

      if (response.data) {

        // Redirect support
        if (typeof response.data.location == 'string') {
          window.location.href = response.data.location;
        } else if (typeof response.data.message == 'string') {
          // Single message support
          this.showCommonMessage(form, response.data.message, 'success');
        }

        if (actionEvent) {
          this.App.Events.publish(actionEvent, response.data);
        }

        return true;

      } else {
        this.onValidationError(
          form,
          this.App.Language.get('errors.internal_error')
        );
      }

    }).catch((error) => {

      this.unlockSubmitButtons(form);

      if (error.response) {

        // @TODO: переосмыслить обработку ошибок и отрефакторить этот ужасный блок

        if (typeof error.response.data.exception == 'string')
          this.onValidationError(form, this.App.Language.get('errors.internal_error'));
        else if (error.response.status !== 500 && typeof error.response.data.errors == 'object')
          this.onValidationError(form, error.response.data.errors);
        else if (error.response.status !== 500 && typeof error.response.data.message == 'string')
          this.onValidationError(form, error.response.data.message);
        else if (error.response.status !== 500 && typeof error.response.data.message == 'object')
          this.onValidationError(form, error.response.data.message);
        else
          this.onValidationError(form, this.App.Language.get('errors.internal_error'));

      } else if (error.request) {
        this.onFailedError(form);
      } else {
        this.onValidationError(form, error.message);
      }

    });

  }

  showCommonMessage(form, message, type) {

    if (typeof type == 'undefined') type = 'error';

    this.logger('Form error', form, message, type);

    let template = this
      ._FORM_ERROR_TEMPLATE
      .replace('%message%', message)
      .replace('%type%', this._MESSAGE_TYPES[type]);

    if (form.hasClass('is-as-modal')) {
      form.before(template);
    } else if (form.hasClass('is-without-ui-form')) {
      return this.App.UI.Dialog.alert(template);
    } else {
      // form.closest('.box').before(template);
      form.before(template);
    }

  }

  showFieldError(form, field, message) {

    this.logger('Field error:', field, message);

    let template = this._FIELD_ERROR_TEMPLATE.replace('%message%', message);

    form
      .find('[name="'+ field +'"]:not([type="checkbox"])')
      .addClass('is-danger')
      .closest('.field-body')
      .children('.field:first')
      .append(template);

    form
      .find('[name="'+ field +'"][type="checkbox"]')
      .closest('.control')
      .append(template);
  }

  resetErrors(form) {
    form.closest('.box').siblings('.message').remove();
    form.siblings('.message').remove();
    form.find('input, select, textarea').removeClass('is-danger');
    form.find('.help.is-danger').remove();
  }

  onValidationError(form, message) {

    if (typeof message == 'string') {
      this.showCommonMessage(form, message);
    } else {

      $.each(message, (field, value) => {

        if (field === 'form') {
          this.showCommonMessage(form, value);
        } else if (typeof value == 'string') {
          this.showFieldError(form, field, value);
        } else if (typeof value != 'string' && typeof value[0] == 'string') {
          this.showFieldError(form, field, value[0]);
        }

      });

    }

  }

  onFailedError(form) {

    this.showCommonMessage(
      form,
      this.App.Language.get('errors.internal_error')
    );

  }

  lockSubmitButtons(form) {
    form.find('button[type="submit"]').prop('disabled', true).addClass('is-loading');
  }

  unlockSubmitButtons(form) {
    form.find('button[type="submit"]').prop('disabled', false).removeClass('is-loading');
  }

}